import gql from 'graphql-tag'

export const GET_PRODUCT_OR_VARIANT_URL_BY_ID = gql`
  query getProductOrVariantUrlById($id: ID!) {
    getProductVariantsByIds(ids: [$id]) {
      id
      mainCategoryUrlKey
      mainVariant {
        variantUrl
      }
    }
    getProductById(id: $id) {
      id
      mainCategoryUrlKey
      mainVariant {
        variantUrl
      }
      variants {
        id
        variantUrl
      }
    }
  }
`
